import { ServiceModel } from '../models/ServiceModel';
import { Auftragsvorlage, Benutzer } from '../api';
import { SendungsstatusModel } from '../models/SendungsstatusModel';
import { dateToIsoDate } from './date';

export const servicesComparator = (a: ServiceModel, b: ServiceModel) => {
  // es soll erst nach active und dann alphabetisch sortiert werden
  // a | b
  // 0 | 0 -> alphabetisch
  // 0 | 1 -> b vor a
  // 1 | 0 -> a vor b
  // 1 | 1 -> alphabetisch

  // ! um boolean zu forcieren, undefined würde sonst die Fallunterscheidung kaputt machen
  if (!a.active === !b.active) {
    // sind beide active oder beide nicht active (XNOR), sortiere alphabetisch
    return a.bezeichnung
      .toLowerCase()
      .localeCompare(b.bezeichnung.toLowerCase(), 'de-DE');
  }
  // ist Service a active, soll a vor b sortiert werden,
  // ansonsten b vor a
  return a.active ? -1 : 1;
};

export const byTextAscending =
  <T>(getTextProperty: (object: T) => string) =>
  (objectA: T, objectB: T) => {
    const upperA = getTextProperty(objectA).toLowerCase();
    const upperB = getTextProperty(objectB).toLowerCase();
    if (upperA < upperB) {
      return -1;
    }
    if (upperA > upperB) {
      return 1;
    }
    return 0;
  }; // Sort by the "name" property

export const byDatumAscending = (
  a: SendungsstatusModel,
  b: SendungsstatusModel
) => {
  if (a?.date && b?.date) {
    return a.date < b.date ? -1 : 1;
  }

  return a.date ? -1 : 1;
};

export const byAnzeigefolge = (
  a: SendungsstatusModel,
  b: SendungsstatusModel
) => {
  if (a.anzeigefolge && b.anzeigefolge) {
    return a.anzeigefolge < b.anzeigefolge ? -1 : 1;
  }
  return 0;
};

export const compareValues = (key: string, order = 'asc') => {
  if (order !== 'default') {
    return function innerSort(a: any, b: any) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }
      let varA = a[key] instanceof String ? a[key].toUpperCase() : a[key];
      let varB = b[key] instanceof String ? b[key].toUpperCase() : b[key];

      if (key === 'datum' || key === 'beladedatum' || key === 'zustellDatum') {
        varA = dateToIsoDate(varA.split('.').reverse().join('-'));
        varB = dateToIsoDate(varB.split('.').reverse().join('-'));
      }

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return order === 'desc' ? comparison * -1 : comparison;
    };
  }
};
